const CustomSelect = (props) => {
    const { selectProps, children, customClass, callBack } = props

    const handleChange = (e) => {
        if (callBack) {
            callBack(e);
        }
    };
    return (
        <div className="relative">
            <select {...selectProps} onChange={handleChange} className={`${customClass} shadow-soft appearance-none border border-neutral-200 rounded-2xl w-full py-2.5 px-3 pr-9 sm:text-base text-sm text-neutral-900 font-medium placeholder:text-neutral-400 placeholder:font-normal focus:outline-none focus:border-primary/60 focus:ring-4 focus:ring-primary/15 focus-visible:outline-none transition-all duration-150 bg-[url('/assets/images/select-arrow.svg')] bg-no-repeat bg-[95%] bg-white`}>
                {children}
            </select>
        </div>
    )
}

export default CustomSelect
